{
  "defaultCurrencyConfig": {
    "symbol": "$",
    "positionLeft": true
  },
  "wrapper": {
    "header": {
      "book-now": "Book Now. ",
      "pay": "Pay Over Time.",
      "powered-by": "Powered by "
    },
    "footer": {
      "uplift": {
        "email": "support@uplift.com"
      },
      "flexpay": {
        "email": "customercare@upgrade.com"
      },
      "telephone": {
        "link": "+18442575400",
        "text": "(844) 257-5400",
        "full": "+1 (844) 257-5400"
      }
    },
    "agent-updated": {
      "message": "Your agent updated your trip's details and/or traveler information. Before continuing, please make sure the updated itinerary is correct.",
      "dismiss": "Dismiss"
    }
  },
  "document-view": {
    "buttons": {
      "close": {
        "label": "Close"
      },
      "print": {
        "label": "Print"
      }
    }
  },
  "time": {
    "months": {
      "1": "Jan",
      "2": "Feb",
      "3": "Mar",
      "4": "Apr",
      "5": "May",
      "6": "Jun",
      "7": "Jul",
      "8": "Aug",
      "9": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    }
  },
  "regions": {
    "AL": "Alabama",
    "AK": "Alaska",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "AA": "Armed Forces Americas",
    "AE": "Armed Forces Europe",
    "AP": "Armed Forces Pacific",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District of Columbia",
    "FL": "Florida",
    "GA": "Georgia",
    "GU": "Guam",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "MP": "Northern Mariana Islands",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PA": "Pennsylvania",
    "PR": "Puerto Rico",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VI": "Virgin Islands",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
  },
  "processing": "Processing...",
  "mcodes": {
    "-100": "",
    "-1": "Oops, something unexpected has happened.",
    "0": "Invalid Application",
    "1": "Sorry, this itinerary does not qualify for Pay Monthly.",
    "2": "Sorry, this itinerary does not qualify for Pay Monthly.",
    "3": "Uh oh, an error occurred processing your request. Try again in a few minutes. If the problem persists, please contact Uplift's support line.",
    "4": "<div><span>Too many verification attempts using this mobile number.</span><br/><span>Please use another number, or try again after 24 hours.</span></div>",
    "5": "Incorrect Verification Code",
    "6": "The Social Security Number does not match.",
    "7": "There are difficulties in verifying your identity, and we are thus unable to process your loan request.",
    "8": "Sorry, the network request timed out. Please try again.",
    "9": "This mobile number is already associated with an account in USA/English",
    "10": "Unsupported region",
    "11": "Unsupported ZIP Code",
    "12": "PO Box addresses are not supported. Please provide a full street address to continue.",
    "13": "Unsupported country",
    "14": "Your session has ended or your previous loan application approval has expired. Please re-apply. A new application will not affect your credit score.",
    "15": "The country associated with your application has changed. Please re-apply. A new application will not affect your credit score.",
    "16": "The language associated with your application has changed. Please re-apply. A new application will not affect your credit score.",
    "17": "The currency associated with your application has changed. Please re-apply. A new application will not affect your credit score.",
    "18": "Transaction declined. Please use a different payment method.",
    "19": "You have exceeded the application time limit. Please re-apply to continue. A new application will not affect your credit score.",
    "20": "<span>It looks like the person who applied for the loan is no longer traveling. Unfortunately, Uplift can only proceed with a loan request for <strong>someone listed on your itinerary</strong>.</span>",
    "50": "Uplift is currently experiencing technical difficulties. Please try again.",
    "51": "Transaction declined. Please use a different payment method.",
    "52": "Sorry, Uplift was unable to access the document you requested. Please try again.",
    "60": "Please make a selection to continue.",
    "61": "Unavailable for {{region}} residents",
    "bls-0": "Internal error. Please provide a new card number.",
    "bls-2": "This form of payment is not accepted. Please provide a new card number.",
    "bls-3": "American Express cards not accepted. Please provide a new card number.",
    "bls-4": "Card is not accepted. Please provide a new card number.",
    "bls-5": "Visa cards are not accepted. Please provide a new card number.",
    "bls-6": "This form of payment is not accepted. Please provide a new card number."
  },
  "documents": {
    "cpa": "Credit Profile Authorization",
    "tos": "Terms of Use",
    "pp": "Privacy Policy",
    "esign": "E-Sign Consent",
    "icc": "Increased Cost of Credit / Adverse Action",
    "loanAgreement": "Loan Agreement",
    "paymentAgreement": "Payment Terms Agreement",
    "til": "Truth in Lending Disclosure",
    "bapn": "Borrower Agreement & Promissory Note",
    "dcd": "Recurring Electronic Payment Authorization",
    "ach": "Authorization for Automatic ACH Payments",
    "wd": "Wisconsin Disclosure",
    "drd": "Debt Ratio Disclosure",
    "wiNotice": "NOTICE TO WI CUSTOMERS",
    "wiDisclaimer": "(a) DO NOT SIGN THIS IF ANY FIELDS ARE LEFT BLANK, SUCH AS ANNUAL PERCENTAGE RATE, FINANCE CHARGE, AMOUNT FINANCED, OR TOTAL OF PAYMENTS. <br/> (b) YOU ARE ENTITLED TO AN EXACT COPY OF ANY AGREEMENT YOU SIGN. <br/> (c) YOU HAVE THE RIGHT AT ANY TIME TO PAY IN ADVANCE THE UNPAID BALANCE DUE UNDER THIS AGREEMENT AND YOU MAY BE ENTITLED TO A PARTIAL REFUND OF THE FINANCE CHARGE."
  },
  "failedToLoad": "<span>{{documentName}} failed to load.</span>",
  "retry": "Retry?",
  "from": "from ",
  "cobrandedLoading": "<UpliftLogo /> is becoming <FlexpayLogo />",
  "flexpay": {
    "productName": "Flex Pay",
    "fullProductName": "Flex Pay by Upgrade",
    "companyName": "Upgrade",
    "fullAddress": "2 N Central Ave., 10th Floor<br/>Phoenix, Arizona 85004",
    "website": "upgrade.com/pay",
    "productMessage": "Flex Pay, formerly known as Uplift,",
    "payableCompanyName": "Upgrade, Inc.",
    "payableCompanyAddressName": "Flex Pay <br>℅ Upgrade, Inc."
  },
  "uplift": {
    "productName": "Uplift",
    "companyName": "Uplift",
    "fullAddress": "2 N Central Ave., 10th Floor<br/>Phoenix, Arizona 85004",
    "website": "pay.uplift.com",
    "payableCompanyName": "Uplift, Inc.",
    "payableCompanyAddressName": "Uplift ℅ Upgrade, Inc."
  }
}
